<template>
    <div class="login-body">
        <main>
            <Loading/>
            <section class="login-section">
                <div class="container-fluid">
                    <div class="container login-container">
                        <div class="row login-row">
<!--                            <div class="language-bar">-->
<!--                                <div class="language-bar-header">-->
<!--                                    <div class="shown-language" v-on:click="langBarStatus = !langBarStatus">-->
<!--                                        <span> Alege Limba </span>-->
<!--                                        <i class="fas fa-sort-down"></i>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="language-dropdown" v-bind:class="{languageOpen: langBarStatus}" ref="dropdownMenu">-->
<!--                                    <a class="flag" v-for="lang in languages" :key="lang.title" @click="changeLocale(lang.language)">-->
<!--                                        <flag :iso="lang.flag" v-bind:squared=false> </flag>-->
<!--                                        <span> {{lang.title}}</span>-->
<!--                                    </a>-->
<!--                                </div>-->
<!--                            </div>-->
                            <div class="col-xl-6 col-lg-6 col-md-4 col-sm-12 col-12 login-col">
                                <div class="client-logo">
                                    <img src="/logo.png">
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-8 col-sm-12 col-12 login-col">
                                <div class="login-form">
                                    <h3> {{$t('login.title')}} </h3>
                                    <form method="POST" id="login-form">
                                        <p class="login-error-info">{{this.error}}</p>
                                        <div class="form-group">
                                            <input type="email" name="email" class="form-control" id="email-input" v-model="input.email" placeholder="Email">
                                            <span class="focus-input"></span>
                                                <span class="symbol-input">
                                                <i class="fa fa-envelope" aria-hidden="true"></i>
                                            </span>
                                        </div>
                                        <div class="form-group">
                                            <input type="password" name="password" class="form-control" id="password-input" v-model="input.password" placeholder="Parola">
                                            <span class="focus-input"></span>
                                            <span class="symbol-input">
                                                <i class="fa fa-lock" aria-hidden="true"></i>
                                            </span>
                                        </div>
                                        <button type="submit" @click.prevent="login()" class="login-button" :disabled="this.$store.loading">
                                            {{$t('loginButton')}}
                                        </button>
                                        <div class="forgot-password" @click="resetPassword()">
                                            <p> {{$t('login.recuperare_parola')}} </p>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    </div>
</template>
<style scoped>
    .login-body{
        background: linear-gradient(to right,#d06161, #2196f3);
        height: 111.1vh;
    }
</style>
<script>
import { loadLanguageAsync } from '../plugins/i18n'
import Loading from '../components/Loading'
import UserService from '../api-services/users.service'

export default {
  name: 'Login',
  components: {
    Loading
  },
  data () {
    return {
      input: {
        email: '',
        password: ''
      },
      error: null,
      langBarStatus: false,
      flagTransition: false,

      languages: [
        { flag: 'us', language: 'en', title: 'English' },
        { flag: 'ro', language: 'ro', title: 'Romana' }
      ]
    }
  },

  methods: {
    login () {
      if (this.input.password.length > 0) {
        this.$store.dispatch('showLoading')
        let data = {
          email: this.input.email,
          password: this.input.password
        }
        this.$store.dispatch('authRequest', data).then((response) => {
          this.$store.dispatch('hideLoading')
          // this.$ability.update(response.data.data)
          this.$router.push('/')
        }).catch((error) => {
          this.$store.dispatch('hideLoading')
          console.log(error)
          this.error = error.response.data.error
        })
      }
    },
    resetPassword () {
      let formData = new FormData(document.getElementById('login-form'))
      UserService.resetPassword(formData).then((response) => {
        this.$notify({
          group: 'succes',
          type: 'success',
          // title: 'Added',
          text: this.$t('success.passwordReset'),
          'animation-type': 'css'
        })
      }).catch((error) => {
        console.log(error)
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: 'Error',
          'animation-type': 'css'
        })
      })
    },
    changeLocale (locale) {
      loadLanguageAsync(locale)
    }
  },
  created () {
    this.$store.dispatch('hideLoading')
    if (this.$store.getters.isAuthenticated) {
      this.$router.push('/')
    }
  }
}
</script>
